/* Ajax cart drawer: open/close, add-to-cart, and line quantity/remove
   controls. Cart state is never re-built in JavaScript - every request
   asks Shopify to also re-render the "cart-drawer" section
   (sections=cart-drawer) and we drop that HTML straight in, so
   sections/cart-drawer.liquid stays the single source of truth. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var isBusy = false;
    var lastFocused = null;

    function getFrame() {
      return drawer.querySelector('.cart-drawer');
    }

    function getErrorEl() {
      return drawer.querySelector('[data-cart-drawer-error]');
    }

    function setBusy(busy) {
      isBusy = busy;
      var frame = getFrame();
      if (frame) frame.classList.toggle('is-updating', busy);
    }

    function showError(message) {
      var errorEl = getErrorEl();
      if (!errorEl) return;
      errorEl.textContent = message || (window.theme && window.theme.strings && window.theme.strings.cartError) || 'Something went wrong. Please try again.';
      errorEl.hidden = false;
    }

    function clearError() {
      var errorEl = getErrorEl();
      if (errorEl) errorEl.hidden = true;
    }

    function updateBadges(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count <= 0;
      });
    }

    function isOpen() {
      return !drawer.hidden;
    }

    function closeOtherOverlays() {
      var helpModal = document.querySelector('[data-help-modal]');
      if (helpModal && !helpModal.hidden) helpModal.hidden = true;
    }

    function openDrawer(origin) {
      // Let the product dialog finish closing before the cart takes focus.
      var transition = { returnFocus: origin || document.activeElement };
      document.dispatchEvent(new CustomEvent('themevo:cart:before-open', { detail: transition }));
      closeOtherOverlays();
      if (!isOpen()) lastFocused = transition.returnFocus;
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('.cart-drawer__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      if (drawer.hidden) return;
      drawer.hidden = true;
      document.body.style.overflow = '';
      var returnTarget = lastFocused;
      if (!returnTarget || !returnTarget.isConnected || returnTarget.closest('[hidden], [aria-hidden="true"]')) {
        returnTarget = document.querySelector('[data-cart-trigger]');
      }
      if (returnTarget && typeof returnTarget.focus === 'function') returnTarget.focus({ preventScroll: true });
    }

    function sectionsUrl() {
      return window.location.pathname + window.location.search;
    }

    function refreshFromSections(sections) {
      if (!sections || !sections['cart-drawer']) return;
      var wasOpen = isOpen();
      var parser = new DOMParser();
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var next = doc.querySelector('[data-cart-drawer]');
      if (!next) return;

      drawer.innerHTML = next.innerHTML;
      var count = parseInt(next.getAttribute('data-cart-item-count'), 10) || 0;
      drawer.setAttribute('data-cart-item-count', String(count));
      updateBadges(count);
      if (wasOpen) drawer.hidden = false;
    }

    function postJSON(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            if (!response.ok) {
              var message = (data && (data.description || data.message)) || 'Cart request failed';
              throw new Error(message);
            }
            return data;
          });
      });
    }

    function addToCart(form) {
      if (isBusy) return;
      var formData = new FormData(form);
      var id = formData.get('id');
      if (!id) return;

      var quantityField = formData.get('quantity');
      var quantity = quantityField ? parseInt(quantityField, 10) || 1 : 1;
      var submitBtn = form.querySelector('[type="submit"]');
      var originalLabel = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = (window.theme && window.theme.strings && window.theme.strings.cartAdding) || 'Adding...';
      }

      setBusy(true);
      clearError();

      var properties = {};
      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string' && value.trim()) properties[match[1]] = value;
      });
      postJSON(form.action.replace(/\/?$/, '.js'), {
        items: [{ id: id, quantity: quantity, properties: properties }],
        sections: 'cart-drawer',
        sections_url: sectionsUrl()
      })
        .then(function (data) {
          refreshFromSections(data.sections);
          openDrawer(submitBtn);
        })
        .catch(function (error) {
          showError(error && error.message);
          openDrawer(submitBtn);
        })
        .finally(function () {
          setBusy(false);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
        });
    }

    function changeLine(line, quantity) {
      if (isBusy || !line) return;
      setBusy(true);
      clearError();

      postJSON((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/change.js', {
        line: parseInt(line, 10),
        quantity: quantity,
        sections: 'cart-drawer',
        sections_url: sectionsUrl()
      })
        .then(function (data) {
          refreshFromSections(data.sections);
        })
        .catch(function (error) {
          showError(error && error.message);
        })
        .finally(function () {
          setBusy(false);
        });
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target.closest) return;

      var trigger = target.closest('[data-cart-trigger]');
      if (trigger) {
        event.preventDefault();
        openDrawer(trigger);
        return;
      }

      if (target.closest('[data-cart-drawer-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var qtyDecrease = target.closest('[data-cart-drawer-qty-decrease]');
      if (qtyDecrease) {
        changeLine(qtyDecrease.getAttribute('data-line'), parseInt(qtyDecrease.getAttribute('data-quantity'), 10));
        return;
      }

      var qtyIncrease = target.closest('[data-cart-drawer-qty-increase]');
      if (qtyIncrease) {
        changeLine(qtyIncrease.getAttribute('data-line'), parseInt(qtyIncrease.getAttribute('data-quantity'), 10));
        return;
      }

      var removeBtn = target.closest('[data-cart-drawer-remove]');
      if (removeBtn) {
        changeLine(removeBtn.getAttribute('data-line'), 0);
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target && event.target.closest ? event.target.closest('form[action$="/cart/add"]') : null;
      if (!form) return;
      event.preventDefault();
      addToCart(form);
    });

    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }

      if (event.key === 'Tab') {
        var focusable = drawer.querySelectorAll('a[href], button:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  });
})();
